import React from 'react'
import Left from './left'
import Right from './right'


const About = () => {
    return (
        <section className='grid grid-cols-1 md:grid-cols-2 gap-2 w-full px-3 md:px-8 ' id='about'>
            <Left/>
            <Right/>
        </section>
    )
}

export default About